<template>
  <v-container fluid>
    <v-card elevation="0">
      <page-header
        title="사이트 등록"
        @saveBtn="saveSiteMaster"
        :custom-button-list="customButtonList"
        :useList="buttonUseList"
      />
      <v-card-text>
        <v-card>
          <v-row no-gutters>
            <v-col cols="12" sm="6">
              <v-card class="pa-2" elevation="0">
                <v-text-field v-model="description" dense sm label="사이트명" outlined hide-details></v-text-field>
              </v-card>
            </v-col>
            <v-col cols="12" sm="3">
              <v-card class="pa-2" elevation="0">
                <v-text-field sm v-model="rec_factor" dense label="REC 가중치" outlined hide-details></v-text-field>
              </v-card>
            </v-col>
            <v-col cols="12" sm="3">
              <v-card class="pa-2" elevation="0">
                <v-menu
                  v-model="installDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="crt_date"
                      label="설치일자"
                      outlined
                      hide-details
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="crt_date" @input="installDate = false" no-title></v-date-picker>
                </v-menu>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="3">
              <v-row no-gutters>
                <v-col cols="12" sm="6">
                  <v-card class="pa-2" elevation="0">
                    <v-text-field
                      v-model="zipNo"
                      label="우편번호"
                      dense
                      outlined
                      hide-details
                      readonly
                    />
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-card
                    class="pa-2 align-center d-flex justify-center"
                    height="100%"
                    width="100%"
                    flat
                    elevation="0"
                  >
                    <v-dialog v-model="addr_dialog" width="1000">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          outlined
                          class="default-btn"
                          color="lighten-2"
                          height="100%"
                          dense
                          v-bind="attrs"
                          v-on="on"
                        >우편번호</v-btn>
                      </template>
                      <v-card>
                        <v-card-title>
                          주소 검색
                          <v-spacer></v-spacer>
                          <v-text-field
                            v-model="addr_keyword"
                            append-icon="mdi-magnify"
                            label="주소 입력"
                            single-line
                            hide-details
                            v-on:keyup.enter="getAddr"
                          >
                            <template v-slot:append>
                              <v-icon @click="getAddr">mdi-magnify</v-icon>
                            </template>
                          </v-text-field>
                        </v-card-title>
                        <v-data-table
                          :headers="searchHeaders"
                          :items="jusoList"
                          :page.sync="page"
                          :items-per-page="itemsPerPage"
                          hide-default-footer
                          class="elevation-1"
                          @page-count="pageCount = $event"
                          @click:row="clickAddressRow($event)"
                        ></v-data-table>
                        <div class="text-center pt-2">
                          <v-pagination v-model="page" :length="pageCount"></v-pagination>
                        </div>
                      </v-card>
                    </v-dialog>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <v-card class="pa-2" elevation="0">
                <v-text-field
                  dense
                  readonly
                  outlined
                  sm
                  v-model="detailAddr"
                  label="사이트 주소"
                  hide-details
                ></v-text-field>
              </v-card>
            </v-col>
            <v-col cols="3">
              <v-card class="pa-2" elevation="0">
                <v-text-field
                  placeholder="숫자만 입력가능"
                  outlined
                  label="FIT 단가"
                  v-model="fit_price"
                  hide-details
                  dense
                  pattern="[0-9]*"
                  type="number"
                ></v-text-field>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="2">
              <v-card class="pa-2" elevation="0">
                <v-select
                  :items="isUseSite"
                  label="사이트 사용여부"
                  item-text="txt"
                  item-value="val"
                  v-model="useyn"
                  hide-details
                  outlined
                  dense
                ></v-select>
              </v-card>
            </v-col>
            <v-col cols="12" sm="2">
              <v-card class="pa-2" elevation="0" flat>
                <v-text-field v-model="site_capa" dense outlined label="사이트 용량" hide-details></v-text-field>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="pa-2" elevation="0">
                <v-select
                  v-model="cctv_stat"
                  :items="cctvType"
                  item-text="name"
                  item-value="value"
                  label="CCTV 구분"
                  @change="cctvStatChange($event)"
                  dense
                  hide-details
                  outlined
                ></v-select>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="pa-2" elevation="0">
                <v-text-field
                  readonly
                  v-model="user_nm"
                  outlined
                  dense
                  sm
                  label="사이트 등록자"
                  hide-details
                />
              </v-card>
            </v-col>
            <v-col cols="3">
              <v-card class="pa-2" elevation="0">
                <v-select
                  :items="agencyList"
                  item-text="name"
                  item-value="value"
                  v-model="agency"
                  hide-details
                  outlined
                  dense
                  label="대리점"
                ></v-select>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="3">
              <v-card class="pa-2" elevation="0">
                <v-select
                  outlined
                  hide-details
                  dense
                  :items="moduleMakerList"
                  v-model="module_maker"
                  label="모듈 제조사"
                ></v-select>
              </v-card>
            </v-col>
            <v-col cols="12" sm="3">
              <v-card class="pa-2" elevation="0">
                <v-text-field v-model="module_type" outlined dense label="모듈 타입" hide-details/>
              </v-card>
            </v-col>
            <v-col cols="12" sm="3">
              <v-card class="pa-2" elevation="0">
                <v-select
                  v-model="roof_floor"
                  dense
                  outlined
                  :items="['대지', '지붕']"
                  hide-details
                  label="대지/지붕"
                ></v-select>
              </v-card>
            </v-col>
            <v-col cols="12" sm="3">
              <v-card class="pa-2" elevation="0">
                <v-text-field v-model="angle" dense label="설치각도" outlined hide-details/>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters v-show="module_maker === '기타'">
            <v-col cols="12" sm="3">
              <v-card class="pa-2" evevation="0">
                <v-text-field
                  v-model="module_maker_direct"
                  outlined
                  hide-details
                  dense
                  label="모듈 제조사 직접입력"
                ></v-text-field>
              </v-card>
            </v-col>
            <v-col cols="12" sm="3">
              <v-card class="pa-2" elevation="0">
                <v-select
                  v-model="onoffyn"
                  dense
                  outlined
                  :items="['Y', 'N']"
                  hide-details
                  label="INVERTER ON/OFF"
                ></v-select>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-show="isCCTV" no-gutters>
            <v-col cols="12" sm="3">
              <v-card class="pa-2" elevation="0">
                <v-text-field v-model="cctv1" outlined hide-details dense label="CCTV1"></v-text-field>
              </v-card>
            </v-col>
            <v-col cols="12" sm="3">
              <v-card class="pa-2" elevation="0">
                <v-text-field v-model="cctv2" outlined hide-details dense label="CCTV2"></v-text-field>
              </v-card>
            </v-col>
            <v-col cols="12" sm="3">
              <v-card class="pa-2" elevation="0">
                <v-text-field v-model="cctv3" outlined hide-details dense label="CCTV3"></v-text-field>
              </v-card>
            </v-col>
            <v-col cols="12" sm="3">
              <v-card class="pa-2" elevation="0">
                <v-text-field v-model="cctv4" outlined hide-details dense label="CCTV4"></v-text-field>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-show="isNVR" no-gutters>
            <v-col cols="12" sm="3">
              <v-card class="pa-2" elevation="0">
                <v-text-field v-model="nvr" outlined hide-details dense label="NVR"></v-text-field>
              </v-card>
            </v-col>
            <v-col cols="12" sm="3">
              <v-card class="pa-2" elevation="0">
                <v-select
                  v-model="cctv_cnt"
                  :items="cctvCntList"
                  item-text="txt"
                  item-value="val"
                  outlined
                  hide-details
                  dense
                  label="CCTV 수"
                ></v-select>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-show="isDVR" no-gutters>
            <v-col cols="12" sm="3">
              <v-card class="pa-2" elevation="0">
                <v-text-field v-model="nvr" outlined hide-details dense label="DVR"></v-text-field>
              </v-card>
            </v-col>
            <v-col cols="12" sm="3">
              <v-card class="pa-2" elevation="0">
                <v-select
                  v-model="cctv_cnt"
                  :items="cctvCntList"
                  item-text="txt"
                  item-value="val"
                  outlined
                  hide-details
                  dense
                  label="CCTV 수"
                ></v-select>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-card-text>
      <v-card-text>
        <v-card>
          <v-card-title>사용자 관리</v-card-title>
          <v-row no-gutters>
            <v-card class="pa-2" outlined width="100%">
              <v-layout justify-space-between>
                <v-dialog v-model="dialog" width="1000">
                  <template v-slot:activator="{ on, attrs }">
                    <v-col cols="6">
                      <v-btn
                        outlined
                        style="max-width: 100%;"
                        class="default-btn"
                        v-bind="attrs"
                        v-on:click="userSet"
                      >
                        <span class="mr-1">사용자 적용</span>
                        <v-icon style="font-size: 14px;">mdi-magnify</v-icon>
                      </v-btn>
                    </v-col>
                  </template>
                  <v-card>
                    <v-card-title class="headline lighten-2">사용자 검색</v-card-title>
                    <v-layout class="d-flex justify-end align-center pl-6 pr-6">
                      <v-col cols="4" sm="3">
                        <v-select
                          v-model="search_type"
                          :items="dialogSearch"
                          style="text-align: center;"
                          item-text="txt"
                          item-value="val"
                          hide-details
                          outlined
                          dense
                        ></v-select>
                      </v-col>
                      <v-col cols="5" sm="6">
                        <v-text-field
                          v-model="search_word"
                          outlined
                          hide-details
                          dense
                          v-on:keyup.enter="searchUser"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" sm="3" class="d-flex justify-center">
                        <v-btn class="default-btn" v-on:click="searchUser">검색</v-btn>
                      </v-col>
                    </v-layout>
                    <v-card-text>
                      <div class="result_table_area">
                        <div
                          style="height: 300px;"
                          id="search_site_realgrid"
                          ref="search_site_realgrid"
                          class="mt-1 mb-5 w-full"
                        ></div>
                      </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="justify-center">
                      <!-- <v-spacer></v-spacer> -->
                      <v-btn outlined class="default-btn" @click="dialog = false">취소</v-btn>
                      <v-btn outlined class="default-btn" @click="applySite">적용</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <!-- <v-btn @click="searchUser">
                  <span class="mr-1">사용자 적용</span>
                  <v-icon style="font-size: 14px;">mdi-magnify</v-icon>
                </v-btn>-->
                <v-col cols="6">
                  <v-btn outlined class="default-btn" style="max-width: 100%;" @click="deleteUser">
                    <v-icon style="font-size: 14px;">mdi-minus</v-icon>
                    <span class="ml-1">선택 사용자 삭제</span>
                  </v-btn>
                </v-col>
              </v-layout>
            </v-card>
          </v-row>
          <v-row no-gutters>
            <v-card class="pa-2" outlined width="100%">
              <v-data-table
                v-model="selectedUser"
                :headers="headers"
                :items="addUserInfos"
                show-select
                :single-select="singleSelect"
                class="elevation-1"
                hide-default-footer
                disable-sort
              >
                <template v-slot:item.use="{ item }">
                  <v-simple-checkbox v-model="item.ownership_yn" :ripple="false"></v-simple-checkbox>
                </template>
                <template v-slot:item.cerr="{ item }">
                  <v-simple-checkbox v-model="item.fail_notice" :ripple="false"></v-simple-checkbox>
                </template>
                <template v-slot:item.crun="{ item }">
                  <v-simple-checkbox v-model="item.run_notice" :ripple="false"></v-simple-checkbox>
                </template>
              </v-data-table>
            </v-card>
          </v-row>
        </v-card>
      </v-card-text>
      <v-card-text class="pb-0">
        <v-card>
          <v-card-title>
            <v-layout cols="6" sm="4" class="d-flex align-center">
              <div class="mr-3">발전 정보 선택</div>
              <v-radio-group row v-model="sunRadio" disabled>
                <v-radio label="태양광" value="sunShine"></v-radio>
                <v-radio label="ESS" value="ess"></v-radio>
              </v-radio-group>
            </v-layout>
            <v-layout cols="12" sm="4"></v-layout>
            <v-layout cols="6" sm="4" class="d-flex justify-end">
              <v-btn outlined class="mr-2" @click="addStation">
                <v-icon style="font-size: 14px;">mdi-plus</v-icon>
                <span class="ml-1">스테이션 추가</span>
              </v-btn>
              <v-btn outlined class="default-btn" @click="delStation">
                <v-icon style="font-size: 14px;">mdi-minus</v-icon>
                <span class="ml-1">스테이션 삭제</span>
              </v-btn>
            </v-layout>
          </v-card-title>
        </v-card>
      </v-card-text>
      <v-card-text>
        <v-card
          class="mb-2"
          elevation="1"
          v-for="(item, idx) in mstations"
          v-bind:key="'sts_'+idx"
          ref="station_box"
          name="station_box"
          outlined
        >
          <v-card-title>
            <v-checkbox
              :id="'station_'+idx"
              v-model="item.isCheck"
              ref="station_check"
              :value="idx"
            ></v-checkbox>
            스테이션 {{ idx + 1 }}
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="3">
                <v-text-field v-model="item.callurl" label="접속 URL" outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field v-model="item.callport" label="포트" outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field v-model="item.callid" label="Call ID" outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field v-model="item.callpwd" label="Call PW" outlined dense hide-details></v-text-field>
              </v-col>
            </v-row>
            <v-layout
              v-for="(intitem, ids) in item.inverters"
              column
              :key="'inverter_'+ids"
              outlined
            >
              <v-row>
                <v-card-subtitle class="d-flex align-center">인버터 {{ ids + 1 }}</v-card-subtitle>
                <v-col cols="12" sm="3">
                  <v-select
                    label="코드 No"
                    :items="inverterTags"
                    item-text="description"
                    item-value="codevalue"
                    v-model="intitem.iolistid"
                    outlined
                    dense
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-select
                    label="유형"
                    :items="inverterModels"
                    item-text="description"
                    item-value="codevalue"
                    v-model="intitem.model"
                    v-on:change="typeChange($event, idx, ids)"
                    :id="inverterModels.attribute1"
                    outlined
                    dense
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field
                    v-model="intitem.pcs_capa"
                    dense
                    label="용량(kW)"
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    label="Serial No"
                    dense
                    v-model="intitem.serial"
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="2">
                  <v-checkbox v-model="intitem.isStr" dense hide-details label="스트링여부"></v-checkbox>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-select
                    label="친트/힘스"
                    outlined
                    dense
                    hide-details
                    :items="chda"
                    item-text="txt"
                    item-value="value"
                    v-model="intitem.string_type"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-select
                    label="숫자"
                    v-model="intitem.string_num"
                    outlined
                    dense
                    hide-details
                    :items="chNumList"
                    item-value="val"
                    item-text="txt"
                  ></v-select>
                </v-col>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-col class="d-flex justify-end align-center">
                  <v-btn v-on:click="addInverter(idx, ids)">+</v-btn>
                  <v-btn v-if="ids !== 0" v-on:click="delInverter(idx, ids)">-</v-btn>
                </v-col>
              </v-row>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>

    <v-dialog persistent max-width="500px" v-model="detailAddressInsertDialog">
      <v-card>
        <v-card-title>
          <span>상세주소 입력</span>
          <v-spacer></v-spacer>
          <v-menu bottom right></v-menu>
        </v-card-title>
        <v-card-text>
          <v-text-field outlined dense label="우편번호" v-model="zipNo" disabled></v-text-field>
          <v-text-field outlined dense label="도로명 주소" v-model="roadAddr" disabled></v-text-field>
          <v-text-field outlined dense label="상세주소" v-model="detailAddr"></v-text-field>
        </v-card-text>
        <v-card-actions class="d-flex justify-center align-center">
          <v-btn color="primary" outlined dense text @click="address_finish">완료</v-btn>
          <v-btn color="primary" outlined dense text @click="detailAddressInsertDialog = false">취소</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { getJuso } from '@/api/greenCommon/juso'
import PageHeader from '@/layout/components/PageHeader'
import RealGridJS from 'realgrid/dist/main'
import { getUsers } from '@/api/greenCommon/user'
import localStore from '@/utils/localStore'

import {
  getSiteDetail,
  setSiteMaster,
  setSiteDelete,
  streamEvent
} from '@/api/master/master'
import { getComCode } from '@/api/master/commonCode'
import {
  syncKepwareDB,
  syncKepwareDBDel,
  getChannel,
  getDevice,
  syncKepwareChannel,
  syncKepwareDevice,
  syncKepwareTag,
  syncKepwareChannelDel,
  reScheduler,
  siteWSync,
  checkDelete
} from '@/api/common/kepware'

// 2020-10-08 다중 CCTV (NVR, DVR) 추가 함수 통합
const cctvNames = ['hik', 'hanhwa', 'idis', 'webgate']
let dataProvider
let gridView

export default {
  components: {
    PageHeader
  },
  props: {
    codenm: { type: String, default: '' }
  },
  data() {
    return {
      selectSggNm: '',
      sido_code: '',
      sigu_code: '',
      isStation: true,
      detailAddressInsertDialog: false,
      singleSelect: false,
      selectedUser: [],
      typekW: '0',
      isString: false,
      isUseSite: [
        { txt: '사용', val: 'Y' },
        { txt: '미사용', val: 'N' },
        { txt: '중지', val: 'S' }
      ],
      site_capa: '',
      codeItems: [
        { value: 'MQTT01', txt: 'MQTT01' },
        { value: 'MQTT02', txt: 'MQTT02' },
        { value: 'MQTT03', txt: 'MQTT_100kW' },
        { value: 'WEB01', txt: '친트(웹서비스)' },
        { value: 'XML01', txt: 'XML01' },
        { value: 'XML02', txt: 'XML02' },
        { value: 'CHINT01', txt: '친트01' },
        { value: 'CHINT02', txt: '친트02' },
        { value: 'CHINT03', txt: '친트03' },
        { value: 'CHINT04', txt: '친트04' },
        { value: 'CHINT05', txt: '친트05' },
        { value: 'CHINT06', txt: '친트06' },
        { value: 'CHINT07', txt: '친트07' },
        { value: 'CHINT08', txt: '친트08' },
        { value: 'CHINT09', txt: '친트09' },
        { value: 'CHINT10', txt: '친트10 ' }
      ],
      codeNextItems: [
        'HPC-050HL-U1-OU',
        'HPC-050HL-K1-OU',
        'HPC-050HT',
        'HPC-100HT',
        'HPC-100HT-K1',
        'HPC-100HT-K1-OM',
        'HPC-100HT-K1-OU',
        'HPC-100HL-V1-OU',
        'HPC-200HT-K1',
        'HPC-200HT-K1-OM',
        'HPC-250HT-K1',
        'HPC-250HT-K1-OM',
        'HPC-500HL-K1',
        'HPC-500HL-K1-OM',
        'HPC-500HL-K2',
        'HPC-500HL-K2-OM',
        'HPC-500HL-K3',
        'HPC-500HL-K3-OM',
        'HPC-500HL-K4',
        'HPC-500HL-K4-OM',
        'HPC-750HL-K1',
        'HPC-750HL-K1-OM',
        'HPC-1000HL-K1',
        'HPC-1000HL-K1-OM'
      ],
      chda: [{ txt: '친트', value: 'C' }, { txt: '힘스', value: 'H' }],
      chNumList: [
        { txt: '0', val: '0' },
        { txt: '1', val: '1' },
        { txt: '2', val: '2' },
        { txt: '3', val: '3' },
        { txt: '4', val: '4' },
        { txt: '5', val: '5' }
      ],
      dialogSearch: [
        { txt: '사용자 ID', val: 'user_id' },
        { txt: '사용자 이름', val: 'user_nm' }
      ],
      sunRadio: 'sunShine',
      page: 1,
      pageCount: 0,
      itemsPerPage: 9,
      searchHeaders: [
        { text: '우편번호', sortable: false, align: 'center', value: 'zipNo' },
        { text: '도로명 주소', sortable: false, value: 'roadAddr' }
      ],
      grid: {
        gridFields: [],
        gridColumns: [],
        gridOption: {},
        gridStyle: {}
      },
      jusoList: [],
      jusoType: '',
      addr_keyword: '',
      currentPage: '1',
      dialog: false,
      addr_dialog: false,
      moduleMakerList: ['현대', 'LG', '신성', 'JA솔라', '기타'],
      date: new Date().toISOString().substr(0, 10),
      installDate: false,
      buttonUseList: [],
      customButtonList: [{ id: 'saveBtn', text: '저장', icon: 'mdi-check' }],
      cctvType: [
        { name: '하이크비전 IPcamera', value: 'CC_hik' },
        { name: '하이크비전 NVR', value: 'NR_hik' },
        { name: '한화테크윈 DVR', value: 'DR_hanhwa' },
        { name: '아이디스 DVR', value: 'DR_idis' },
        { name: '웹게이트 NVR', value: 'NR_webgate' },
        { name: '사용안함', value: 'N' }
      ],
      agencyList: [
        { name: '기타', value: '기타' },
        { name: '신명엔지니어링', value: '신명엔지니어링' },
        { name: '프라나솔루션', value: '프라나솔루션' },
        { name: '프라임에너지', value: '프라임에너지' },
        { name: 'HD에너지', value: 'HD에너지' },
        { name: '유지에스', value: '유지에스' },
        { name: '대청에너지', value: '대청에너지' },
        { name: '세림이엔지', value: '세림이엔지' },
        { name: '광진솔라이엔지', value: '광진솔라이엔지' },
        { name: '현대솔라', value: '현대솔라' },
        { name: '현대넥솔', value: '현대넥솔' },
        { name: '그린솔라', value: '그린솔라' },
        { name: '한중에너지', value: '한중에너지' }
      ],
      module_maker_direct: '',
      module_show: false,
      fit_price: '',
      module_maker: '기타',
      module_type: '',
      roof_floor: '',
      onoffyn: '',
      angle: '',
      agency: { value: '기타' },
      monitorShow: true,
      site_id: '',
      search_type: 'user_id',
      search_word: '',
      isSync: false,
      isWSync: false,
      isDelSync: false,
      isSiteDel: false,
      isNVR: false,
      isDVR: false,
      isCCTV: false,
      kepchannel: 0,
      layer_type: 'Juso',
      component_key: 0,
      component_show: false,
      rec_factor: '1.2',
      crt_date: this.$time(Date.now()).format('YYYY-MM-DD'),
      description: '',
      siNm: '',
      zipNo: '',
      roadAddr: '',
      detailAddr: '',
      loc_lat: '',
      loc_lon: '',
      useyn: 'Y',
      cctv_stat: 'N', // CC:CCTV NR:NVR DR:DVR N:사용안함
      nvr: '', // NVR or DVR IP&PORT
      cctv_cnt: '1', // NVR or DVR에 연결된 CCTV대수
      cctvCntList: [
        { txt: '1대', val: '1' },
        { txt: '2대', val: '2' },
        { txt: '3대', val: '3' },
        { txt: '4대', val: '4' }
      ],
      cctv1: '', // CCTV1 IP&PORT
      cctv2: '', // CCTV2 IP&PORT
      cctv3: '', // CCTV3 IP&PORT
      cctv4: '', // CCTV4 IP&PORT
      userId: '',
      user_nm: '',
      siteId: '',
      addr_input: true,
      userInfos: [],
      addUserInfos: [],
      planttype: 'P',
      mstations: [{ inverters: [{ isUse: 'Y' }] }],
      inverters: [[0]],
      inverterTags: [],
      inverterModels: [],
      saveIng: true,
      saveData: {},
      headers: [
        { text: '이름', value: 'kor_nm' },
        { text: 'ID', value: 'user_id' },
        { text: '권한', value: 'ownership_yn' },
        { text: '이메일', value: 'email' },
        { text: '전화번호', value: 'phone' },
        { text: '소유여부', value: 'use' },
        { text: '고장알림', value: 'cerr' },
        { text: '가동알림', value: 'crun' }
      ]
    }
  },
  created() {
    this.grid.gridOption = {
      panel: {
        visible: false
      },
      stateBar: {
        visible: false
      },
      checkBar: {
        visible: true
      },
      indicator: {
        visible: false
      },
      footer: {
        visible: false
      },
      edit: {
        // 데이터 편집
        appendable: false,
        insertable: false,
        deletable: false,
        readOnly: false,
        editable: false,
        updatable: false
      },
      header: {
        // gridView 헤더 설정
        height: 30,
        styles: {
          fontSize: '14',
          fontFamily: 'NanumGothic',
          foreground: '#fff',
          fontBold: 'false',
          background: '#5c97cd',
          selectedBackground: '#9bb2c7',
          borderLeft: '#fff',
          borderRight: '#fff'
        },
        selection: {
          background: '#efefef',
          border: '#ccc,1'
        }
      },
      display: {
        // 그리드 표시 정보 설정
        fitStyle: 'evenFill', // 컬럼 너비 자동 조절
        heightMeasurer: 'fixed',
        rowHeight: 30,
        focusVisible: false, // 클릭시 포커스
        showEmptyMessage: true,
        emptyMessage: '조회된 정보가 없습니다.'
      },

      sorting: {
        handleColor: '#fff', // 필터된 헤더 화살표 색상
        hoveredHandleColor: '#fff'
      },
      select: {
        style: 'singleRow' // 선택시 스타일
      }
    }

    this.grid.gridStyle = {
      // gridView 스타일

      body: {
        fontSize: '14',
        fontFamily: 'NanumGothic',
        foreground: '#666',
        fontBold: 'false',
        borderLeft: '#fff,0',
        borderRight: '#ccc,1',
        borderBottom: '#ccc,1',
        empty: {
          textAlignment: 'center',
          lineAlignment: 'center',
          fontSize: 14,
          fontBold: false
        },
        dynamicStyles: [
          {
            criteria: '(row mod 2) = 0',
            styles: {
              background: '#F4F4FA'
            }
          }
        ]
      }
    }
    if (this.$router.history.current.query.site_id !== undefined) {
      this.site_id = this.$router.history.current.query.site_id
    }

    this.init_cmm_data()
  },
  mounted() {
    this.init_data()

    console.log(this.$router.history.current)
    // this.init_grid()
  },
  watch: {
    module_maker: function(newVal) {
      if (
        newVal === '현대' ||
        newVal === '한화' ||
        newVal === 'LG' ||
        newVal === '신성' ||
        newVal === 'JA솔라'
      ) {
        this.module_show = false
      } else {
        this.module_show = true
      }
    },
    fit_price: function(newVal) {
      return (this.fit_price = this.fit_price.replace(/[^0-9]/g, ''))
    }
  },
  methods: {
    address_finish() {
      this.addr_keyword = ''
      this.jusoList = []
      this.detailAddr = this.roadAddr + ', ' + this.detailAddr
      this.detailAddressInsertDialog = false
      this.addr_dialog = false
    },
    clickAddressRow(v) {
      this.sido_code = v.admCd.substr(0, 2)
      this.sigu_code = v.admCd.substr(2, 3)
      this.zipNo = v.zipNo
      this.roadAddr = v.roadAddr
      this.detailAddr = ''
      this.detailAddressInsertDialog = true
      // this.addr_dialog = false
    },
    searchUser() {
      let params = {}
      params = {
        // 2020-02-10 김진희 - user_id 전달하게함
        user_id: localStore.get('userId'),
        search_type: this.search_type,
        search_word: this.search_word
      }

      getUsers(params).then(response => {
        this.users = response
        dataProvider.fillJsonData(this.users)
      })
    },
    applySite() {
      let checkItems = gridView.getCheckedRows(true)
      // let userInfos = []
      for (let index = 0; index < checkItems.length; index++) {
        this.addUserInfos.push(dataProvider.getJsonRow(checkItems[index]))
      }
      // this.addUserInfos = userInfos
      this.dialog = false
    },
    typeChange(d, sIdx, iIdx) {
      this.mstations[sIdx].inverters[iIdx].pcs_capa = parseInt(d.split('-')[1])
    },
    getAddr() {
      let params = {
        currentPage: this.currentPage,
        keyword: this.addr_keyword
      }
      getJuso(params).then(response => {
        if (response.results.common.totalCount === 0) {
          this.jusoType = 'jibun'
          // naver.maps.Service.geocode(
          //   {
          //     query: this.keyword
          //   },
          //   function(status, response) {
          //     if (response.v2.addresses.length !== 0) {
          //       this.jibunList = response.v2.addresses
          //     }
          //   }.bind(this)
          // )
        } else {
          this.jusoType = 'road'
          this.jusoList = response.results.juso
          this.selectSggNm = response.results.juso[0].sggNm
        }
      })
    },
    userSet(on) {
      this.dialog = true
      setTimeout(() => {
        this.init_grid()
      }, 100)
    },
    init_grid() {
      if (!gridView) {
        dataProvider = new RealGridJS.LocalDataProvider()
        gridView = new RealGridJS.GridView('search_site_realgrid')
        gridView.setDataSource(dataProvider)

        gridView.setOptions(this.grid.gridOption)
        // gridView.setStyles(this.grid.gridStyle)

        let fields = [
          { fieldName: 'kor_nm', dataType: 'string' },
          { fieldName: 'user_id', dataType: 'string' },
          { fieldName: 'usergroup_title', dataType: 'string' },
          { fieldName: 'email', dataType: 'string' },
          { fieldName: 'phone', dataType: 'string' },
          { fieldName: 'ownership_yn', dataType: 'boolean' },
          { fieldName: 'fail_notice', dataType: 'boolean' },
          { fieldName: 'run_notice', dataType: 'boolean' }
        ]

        let columns = [
          {
            name: 'kor_nm',
            fieldName: 'kor_nm',
            header: { text: '사용자명' },
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'user_id',
            fieldName: 'user_id',
            header: { text: '사용자 ID' },
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'usergroup_title',
            fieldName: 'usergroup_title',
            header: { text: '그룹' },
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'email',
            fieldName: 'email',
            header: { text: 'email' },
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'phone',
            fieldName: 'phone',
            header: { text: 'phone' },
            styles: {
              textAlignment: 'center'
            }
          }
        ]

        dataProvider.setFields(fields)
        gridView.setColumns(columns)
        gridView.setDisplayOptions({
          showEmptyMessage: true,
          emptyMessage: '조회된 데이터가 없습니다.'
        })
        this.searchUser()
      }
    },
    monitorShowf() {
      if (this.description === '') {
        this.monitorShow = false
      } else {
        this.monitorShow = true
      }
    },
    toMonitor() {
      if (this.site_id.substr(0, 1) === 'E') {
        this.$router.push('../ess/siteWork?site_id=' + this.site_id)
      } else {
        this.$router.push('../siteWork?site_id=' + this.site_id)
      }
    },
    init_cmm_data() {
      getComCode('A0016').then(response => {
        this.inverterTags = response
        getComCode('A0018').then(response => {
          this.inverterModels = response
        })
      })
    },
    init_data() {
      const _this = this
      if (this.codenm !== '') {
        let params = {
          codenm: this.codenm
        }
        getSiteDetail(params).then(response => {
          console.log(response)
        })
      }
      if (this.site_id !== undefined && this.site_id !== '') {
        let params = {
          codenm: this.site_id
        }

        getSiteDetail(params).then(response => {
          console.log('#########################################')
          console.log('#########################################')
          console.log(response)
          console.log('#########################################')
          console.log('#########################################')
          for (let i = 0; i < response.userInfos.length; i++) {
            response.userInfos[i].ownership_yn === 'Y'
              ? (response.userInfos[i].ownership_yn = true)
              : (response.userInfos[i].ownership_yn = false)
            response.userInfos[i].fail_notice === 'Y'
              ? (response.userInfos[i].fail_notice = true)
              : (response.userInfos[i].fail_notice = false)
            response.userInfos[i].run_notice === 'Y'
              ? (response.userInfos[i].run_notice = true)
              : (response.userInfos[i].run_notice = false)
          }
          this.isSiteDel = true
          this.rec_factor = response.siteInfo.rec_factor
          this.crt_date = response.siteInfo.crt_date
          this.description = response.siteInfo.description
          this.siNm = response.siteInfo.siNm
          this.zipNo = response.siteInfo.zipNo
          this.roadAddr = response.siteInfo.roadAddr
          this.detailAddr = response.siteInfo.roadAddr
          this.site_capa = response.siteInfo.site_capa

          this.loc_lat = response.siteInfo.loc_lat
          this.loc_lon = response.siteInfo.loc_lon

          this.useyn = response.siteInfo.useyn
          this.kepchannel = response.siteInfo.kepchannel
          this.cctv_stat = response.siteInfo.cctv_stat
          this.nvr = response.siteInfo.nvr
          this.cctv_cnt = response.siteInfo.cctv_cnt
          this.cctv1 = response.siteInfo.cctv1
          this.cctv2 = response.siteInfo.cctv2
          this.cctv3 = response.siteInfo.cctv3
          this.cctv4 = response.siteInfo.cctv4
          this.userId = response.siteInfo.userId
          this.user_nm = response.siteInfo.user_nm
          this.agency = response.siteInfo.agency
          this.module_maker = response.siteInfo.module_maker
          this.module_type = response.siteInfo.module_type
          this.roof_floor = response.siteInfo.roof_floor
          this.onoffyn = response.siteInfo.onoffyn
          this.angle = response.siteInfo.angle
          this.fit_price = response.siteInfo.fit_price
          this.module_maker_direct = response.siteInfo.module_maker
          this.sido_code = response.siteInfo.sido_code
          this.sigu_code = response.siteInfo.sigu_code

          // CCTV 구분에 따라 선택 이벤트 발생
          this.cctvStat(this.cctv_stat)

          if (this.site_id.indexOf('W') > -1) {
            this.isWSync = true
          }

          if (this.kepchannel > 0) {
            this.isDelSync = true
          } else {
            this.isSync = true
          }

          let stations = []
          console.log(response)
          _this.mstations = response.stations
          $(response.stations).each(function(stnIdx, stnItem) {
            stations.push(stnIdx)
          })
          this.stations = stations
          this.addUserInfos = response.userInfos
          // 바로 돌리면 화면에서 반응을 못함...
          // setTimeout(() => {
          //   $(response.stations).each(
          //     function(stnIdx, stnItem) {
          //       $(stnItem.inverters).each(
          //         function(invIdx, invItem) {
          //           this.addResInverter(stnIdx, invIdx)
          //         }.bind(this)
          //       )
          //     }.bind(this)
          //   )

          //   $(this.stations).each(
          //     function(index) {
          //       this.inverterBtn(index)
          //     }.bind(this)
          //   )

          //   this.dataMaapping(response)
          // }, 1000)
        })
      } else {
        console.log('신규 등록')
        this.modelChange('0', '0')
      }
    },
    dataMaapping(response) {
      $(response.stations).each(
        function(stnIdx, stnItem) {
          $('#callurl_' + stnIdx).val(stnItem.callurl)
          $('#callport_' + stnIdx).val(stnItem.callport)
          $('#callid_' + stnIdx).val(stnItem.callid)
          $('#callpwd_' + stnIdx).val(stnItem.callpwd)

          if (stnItem.callid === null) {
            $('#callid_' + stnIdx).val('')
          }
          if (stnItem.callpwd === null) {
            $('#callpwd_' + stnIdx).val('')
          }

          $(stnItem.inverters).each(
            function(invIdx, invItem) {
              if (invItem.iolistid === 'XML01') {
                this.isSync = false
                this.isDelSync = false
              }
              $('#iolistid_' + stnIdx + '_' + invIdx).val(invItem.iolistid)
              $('#model_' + stnIdx + '_' + invIdx).val(invItem.model)
              $('#pcs_capa_' + stnIdx + '_' + invIdx).val(invItem.pcs_capa)
              $('#string_yn_' + stnIdx + '_' + invIdx).val(invItem.string_yn)
              if (invItem.string_num !== '0') {
                $('#string_yn_' + stnIdx + '_' + invIdx).prop('checked', true)
              }
              let stringType = 'C'
              if (invItem.string_type !== null) {
                stringType = invItem.string_type
              }
              let serial = ''
              if (invItem.serial !== null) {
                serial = invItem.serial
              }
              $('#serial_' + stnIdx + '_' + invIdx).val(serial)
              $('#string_type_' + stnIdx + '_' + invIdx).val(stringType)
              let stringNum = '0'
              if (invItem.string_num !== null) {
                stringNum = invItem.string_num
              }
              $('#string_num_' + stnIdx + '_' + invIdx).val(stringNum)
            }.bind(this)
          )
        }.bind(this)
      )

      this.userInfos = response.userInfos
    },
    siteDel() {
      if (confirm('삭제하시겠습니까?\n삭제시 복구 불가능합니다.')) {
        if (this.site_id !== undefined && this.site_id !== '') {
          let params = {
            channelid: this.site_id
          }

          if (this.kepchannel === 0) {
            params = {
              site_id: this.site_id
            }
            setSiteDelete(params).then(response => {
              alert('삭제 되었습니다.')
              this.$router.push('/master/siteManage')
            })
          } else {
            // kep ware 조회 후
            syncKepwareChannelDel(this.site_id).then(channelResponse => {
              syncKepwareDBDel(params).then(response => {
                params = {
                  site_id: this.site_id
                }
                setSiteDelete(params).then(response => {
                  alert('삭제 되었습니다.')
                  this.$router.push('/master/siteManage')
                })
              })
            })
          }
        }
      } else {
        return false
      }
    },
    sysKepwareTag() {
      let params = {
        channelid: this.site_id
      }
      syncKepwareTag(params).then(syncKepwareTagResponse => {
        alert('동기화 되었습니다.')
        return false
      })
    },
    siteWSync() {
      let params = {
        channelid: this.site_id
      }
      siteWSync(params)
        .then(response => {
          this.isWSync = false

          alert('동기화 되었습니다.')
        })
        .catch(reject => {
          alert('동기화에 실패 실패했습니다.')
        })
    },
    reSchedulerSync() {
      let params = {
        edgeid: 'HGE_' + this.site_id + '_0001'
      }
      reScheduler(params).then(response => {})
    },
    siteSync() {
      if (this.site_id !== undefined && this.site_id !== '') {
        let params = {
          channelid: this.site_id
        }

        // DB에 데이터 있는지 확인. 없으면 insert 있으면 error
        syncKepwareDB(params).then(response => {
          if (response.kepcnt > 0) {
            alert('이미 동기화된 사이트 입니다. 삭제후 다시 동기화 해주세요.')
            return false
          } else {
            // kepware 데이터 셋팅을 위한 조회
            getChannel(this.site_id).then(channelResponse => {
              let syncChannelList = {
                companyid: channelResponse.companyid,
                systemid: channelResponse.systemid,
                name: channelResponse.channelid,
                description: channelResponse.description,
                driver: channelResponse.devicedriver,
                insuser: null,
                upduser: null
              }
              // kepware 통신
              syncKepwareChannel(syncChannelList)
                .then(syncChannelResponse => {
                  getDevice(this.site_id).then(deviceResponse => {
                    let deviceList = []
                    $(deviceResponse).each(function(index, item) {
                      if (item.ethernetport === null) {
                        item.ethernetport = ''
                      }
                      let device = {
                        byteorder: item.byteorder,
                        channelid: item.channelid,
                        companyid: item.companyid,
                        description: item.description,
                        devicedriver: item.devicedriver,
                        deviceid: item.deviceid,
                        devicemodel: item.devicemodel,
                        ethernetport: item.ethernetport,
                        firstdwordlow: item.firstdwordlow,
                        firstwordlow: item.firstwordlow,
                        insuser: item.insuser,
                        iolistid: item.iolistid,
                        modiconbitorder: item.modiconbitorder,
                        networkstring: item.networkstring,
                        scanmode: item.scanmode,
                        systemid: item.systemid,
                        treatlongs: item.treatlongs,
                        upduser: item.upduser
                      }
                      deviceList.push(device)
                    })
                    syncKepwareDevice(deviceList)
                      .then(syncDeviceResponse => {
                        syncKepwareTag(params)
                          .then(syncKepwareTagResponse => {
                            this.kepchannel = 1
                            this.isDelSync = true
                            this.isSync = false
                            alert('동기화되었습니다.')
                            return false
                          })
                          .catch(reject => {
                            this.syncError()
                            alert('Tag 생성에 실패했습니다.')
                            console.log('Tag 동기화 실패!')
                          })
                      })
                      .catch(reject => {
                        this.syncError()
                        alert('Device 생성에 실패했습니다')
                        console.log('Device 동기화 실패!')
                      })
                  })
                })
                .catch(reject => {
                  this.syncError()
                  alert('Channel 생성에 실패했습니다.')
                  console.log('Channel 동기화 실패!')
                })
            })
          }
        })
      }
    },
    siteSyncDel() {
      if (this.site_id !== undefined && this.site_id !== '') {
        let params = {
          channelid: this.site_id
        }

        checkDelete(params)
          .then(response => {
            alert('동기화 삭제 완료')
            this.isDelSync = false
            if (this.site_id.indexOf('W') > -1) {
              this.isWSync = true
            } else {
              this.isSync = true
            }
          })
          .catch(reject => {
            alert('동기화 취소에 실패했습니다.')
          })
      }
    },
    syncError() {
      // 동기화 에러시 kepware db 모두 삭제
      let params = {
        channelid: this.site_id
      }
      syncKepwareChannelDel(this.site_id).then(response => {
        alert('동기화 취소 완료')
        this.isDelSync = false

        this.isSync = true
      })
      syncKepwareDBDel(params).then(response => {
        alert('동기화 취소 완료')
        this.isDelSync = false

        this.isSync = true
      })
    },
    juso_api() {
      this.addr_input = true
      this.layer_type = 'Juso'
      this.component_key++
      this.component_show = true
    },
    getJusoGeo() {
      // naver.maps.Service.geocode(
      //   {
      //     query: this.roadAddr
      //   },
      //   function(status, response) {
      //     this.loc_lat = response.v2.addresses[0].y
      //     this.loc_lon = response.v2.addresses[0].x
      //   }.bind(this)
      // )
    },
    // searchUser() {
    //   this.layer_type = 'UserSearch'
    //   this.component_key++
    //   this.component_show = true
    // },
    addUser() {
      $(this.addUserInfos).each(
        function(index, item) {
          this.userInfos.push(this.addUserInfos[index])
        }.bind(this)
      )
    },
    deleteUser() {
      console.log(this.selectedUser)
      $("input[name='user_checked']").each(
        function(index, item) {
          if ($(item).is(':checked')) {
            this.userInfos.splice(index, 1)
          }
        }.bind(this)
      )
      $("input[name='user_checked']").prop('checked', false)
    },
    userOwnership(index) {
      if ($('#ownership_' + index).is(':checked')) {
        this.userInfos[index].ownership_yn = 'Y'
      } else {
        this.userInfos[index].ownership_yn = 'N'
      }
    },
    userFailNotice(index) {
      if ($('#fail_notice_' + index).is(':checked')) {
        this.userInfos[index].fail_notice = 'Y'
      } else {
        this.userInfos[index].fail_notice = 'N'
      }
    },
    userRunNotice(index) {
      if ($('#run_notice_' + index).is(':checked')) {
        this.userInfos[index].run_notice = 'Y'
      } else {
        this.userInfos[index].run_notice = 'N'
      }
    },
    addStation() {
      // let sts = this.mstations.length
      // this.mstations.push(sts + 1)
      this.mstations.push({
        callid: '',
        callport: '',
        callpwd: '',
        callurl: '',
        inverters: [
          {
            isUse: 'Y',
            isStr: false,
            serial: '',
            string_num: '',
            string_type: ''
          }
        ]
      })
    },
    delStation() {
      for (let index = 0; index < this.$refs.station_check.length; index++) {
        let chk = this.$refs.station_check[index]
        if (chk.$refs.input.checked) {
          console.log(chk.id)
          let ix = parseInt(new RegExp('[0-9]+').exec(chk.id)[0])
          this.mstations.splice(ix, 1)
          // this.$delete(this.mstations, chk.value)
          // $(this.$refs.station_box[chk.value]).remove()
        }
      }
    },
    addInverter(stnIdx, invIdx) {
      this.mstations[stnIdx]['inverters'].push({
        iolistid: null,
        isStr: false,
        model: null,
        pcs_capa: '0',
        serial: '',
        string_num: '',
        string_type: '',
        isUse: 'Y'
      })
    },
    addResInverter(stnIdx, invIdx) {
      $('#btnAdd_' + stnIdx + '_' + invIdx).hide()
      $('#inverter_' + stnIdx + '_' + invIdx).show()
    },
    delInverter(stnIdx, invIdx) {
      if (this.mstations[stnIdx].inverters.length > 1) {
        this.mstations[stnIdx]['inverters'].splice(invIdx, 1)
      }
      // this.inverterBtn(stnIdx)
    },
    inverterBtn(stnIdx) {
      let btn = false
      $("span[name='btnAdd_" + stnIdx + "']").each(function(item) {
        if ($(this).is(':visible')) {
          btn = true
          return false
        }
      })

      if (!btn) {
        let stationIdx = $("div[name='inverter_" + stnIdx + "']:visible")
          .last()
          .attr('station_idx')
        let inverterIdx = $("div[name='inverter_" + stnIdx + "']:visible")
          .last()
          .attr('inverter_idx')

        $('#btnAdd_' + stationIdx + '_' + inverterIdx).show()
      }
    },
    modelChange(stationIdx, inverterIdx) {
      let pcsCapa = $(
        '#model_' + stationIdx + '_' + inverterIdx + ' option:selected'
      ).attr('atr')

      $('#pcs_capa_' + stationIdx + '_' + inverterIdx).val(pcsCapa)
    },
    stringyn(stationIdx, inverterIdx) {
      if ($('#string_yn_' + stationIdx + '_' + inverterIdx).is(':checked')) {
        $('#string_type_' + stationIdx + '_' + inverterIdx).val('C')
      }
    },
    saveSiteMaster() {
      if (this.description === null || this.description === '') {
        alert('사이트명을 입력해 주세요.')
        return
      }
      if (this.roadAddr === null || this.roadAddr === '') {
        alert(
          '사이트 주소는 필수 입력입니다.\n우편번호 버튼을 클릭하여 주소를 검색해주세요.'
        )
        return
      }
      if (this.agency.value === null || this.agency.value === '') {
        alert('대리점을 지정해 주세요')
        return
      }

      if (
        this.module_maker === null ||
        this.module_maker === '' ||
        this.module_type === null ||
        this.module_type === '' ||
        this.roof_floor === null ||
        this.roof_floor === ''
      ) {
        alert('모듈 제조사, 모듈 타입, 대지/지붕 항목은 필수 입력 입니다.')
        return
      }

      if (
        this.module_maker === '기타' &&
        (this.module_maker_direct === null || this.module_maker_direct === '')
      ) {
        alert('모듈 제조사, 모듈 타입, 대지/지붕 항목은 필수 입력 입니다.')
        return
      }

      let isiolist = true
      let iolist = this.iolist
      let ioCompare = iolist

      $("select[name='iolist']:visible").each(function(index, item) {
        if (iolist !== ioCompare) {
          isiolist = false
          return false
        } else {
          ioCompare = $(item).val().substr(0, 1)
        }
      })

      if (!isiolist) {
        alert('CHINT, XML, MQTT, SOFAR 타입과 같이 사용하실 수 없습니다.') // 같은 프로콜의 인버터만 사용 가능
        return
      }

      let ioSite = 'A'
      if (ioCompare === 'X') {
        ioSite = 'W'
      } else if (ioCompare === 'M' && this.site_id.substr(0, 1) === 'M') { // 기존 M사이트는 M으로 처리
        ioSite = 'M'
      } else if (ioCompare === 'M' && (this.site_id === undefined || this.site_id === '' || this.site_id.substr(0, 1) === 'N')) { // 신규 등록하는 MQTT 는 N코드로 등록함
        ioSite = 'N'
      } else if (ioCompare === 'S') {
        ioSite = 'S'
      }

      if (this.iolistid === null) {
        alert('코드 No 를 선택해 주세요.')
        this.isStation = false
        return false
      }
      if (this.model === null) {
        alert('유형을 선택해 주세요.')
        this.isStation = false
        return false
      }
      if (this.pcsCapa === null) {
        alert('용량을 입력해 주세요.')
        this.isStation = false
        return false
      }
      if (this.serial === null) {
        if (ioSite === 'M' || ioSite === 'N') {
          alert('serial번호를 입력해 주세요.')
          this.isStation = false
          return false
        }
      }
      if (this.stringType === null) {
        alert('String TYPE을 선택해 주세요.')
        this.isStation = false
        return false
      }
      if (this.stringNum === null) {
        this.stringNum = '0'
      }

      if (this.description == null) {
        alert('사이트명을 입력해 주세요.')
        return
      }
      if (this.rec_factor == null) {
        this.rec_factor = '1.2'
      }
      if (this.siNm == null) {
        this.siNm = ''
      }
      if (this.zipNo == null) {
        this.zipNo = ''
      }
      if (this.roadAddr == null) {
        this.roadAddr = ''
      }
      if (this.crt_date == null) {
        this.crt_date = this.$time(Date.now()).format('YYYY-MM-DD')
      }
      if (this.roadAddr == null) {
        this.useyn = 'Y'
      }
      if (!this.isStation) {
        return
      }

      // CCTV 구분 validation
      if (this.cctv_stat) {
        if (this.cctv_stat.indexOf('NR_') > -1) {
          if (!this.nvr) {
            alert('NVR 정보를 입력해주세요.')
            return
          }
          if (this.cctv_cnt < 1) {
            alert('CCTV 대수를 선택해주세요.')
            return
          }
        } else if (this.cctv_stat.indexOf('DR_') > -1) {
          if (!this.nvr) {
            // dvr 정보는 nvr 변수와 공유
            alert('DVR 정보를 입력해주세요.')
            return
          }
          if (this.cctv_cnt < 1) {
            alert('CCTV 대수를 선택해주세요.')
            return
          }
        } else if (this.cctv_stat.indexOf('CC_') > -1) {
          if (this.cctv1 || this.cctv2 || this.cctv3 || this.cctv4) {
          } else {
            alert('CCTV 정보를 입력해주세요.')
            return
          }
        }
      }

      // 모듈 제조사 직접 입력시 저장 값 기타 -> 입력 값 변경
      if (
        this.module_maker !== '현대' &&
        this.module_maker !== '한화' &&
        this.module_maker !== 'LG' &&
        this.module_maker !== '신성' &&
        this.module_maker !== 'JA솔라'
      ) {
        this.module_maker = this.module_maker_direct
      }
      if (this.selectSggNm) {
        naver.maps.Service.geocode(
          {
            query: this.selectSggNm
          },
          (status, response) => {
            if (status !== naver.maps.Service.Status.OK) {
              console.log('################FAIL##################')
              console.log('################FAIL##################')
              console.log('################FAIL##################')
              console.log('################FAIL##################')
            } else {
              this.loc_lon = response.v2.addresses[0].x
              this.loc_lat = response.v2.addresses[0].y
            }
          }
        )
      }
      this.saveData = {
        siteMaster: {
          site_id: this.site_id,
          siteInfo: {
            sggNm: this.selectSggNm,
            sido_code: this.sido_code,
            sigu_code: this.sigu_code,
            site_capa: this.site_capa,
            fit_price: this.fit_price,
            module_maker: this.module_maker,
            module_type: this.module_type,
            roof_floor: this.roof_floor,
            onoffyn: this.onoffyn,
            angle: this.angle,
            agency: this.agency,
            planttype: 'P',
            rec_factor: this.rec_factor,
            crt_date: this.crt_date,
            description: this.description,
            siNm: this.siNm,
            zipNo: this.zipNo,
            roadAddr: this.detailAddr,
            loc_lat: this.loc_lat,
            loc_lon: this.loc_lon,
            useyn: this.useyn,
            ioSite: ioSite,
            cctv_stat: this.cctv_stat,
            cctv_cnt:
              this.cctv_stat.indexOf('NR_') > -1 ||
              this.cctv_stat.indexOf('DR_') > -1
                ? this.cctv_cnt
                : 1,
            nvr:
              this.cctv_stat.indexOf('NR_') > -1 ||
              this.cctv_stat.indexOf('DR_') > -1
                ? this.nvr
                : '',
            cctv1: this.cctv_stat.indexOf('CC_') > -1 ? this.cctv1 : '',
            cctv2: this.cctv_stat.indexOf('CC_') > -1 ? this.cctv2 : '',
            cctv3: this.cctv_stat.indexOf('CC_') > -1 ? this.cctv3 : '',
            cctv4: this.cctv_stat.indexOf('CC_') > -1 ? this.cctv4 : ''
          },
          stations: this.mstations,
          userInfos: this.addUserInfos
        }
      }
      // let is = true
      // if (is) {
      //   console.log(this.saveData, ': this saveData')
      //   return false
      // }
      if (this.saveIng) {
        this.saveIng = false
        setSiteMaster(this.saveData)
          .then(response => {
            this.saveIng = true
            alert('저장되었습니다.')
            this.wowzaEvent()
          })
          .catch(reject => {
            this.saveIng = true
            alert('저장 실패했습니다.')
            return false
          })
      } else {
        alert('저장중입니다. 잠시후 다시 요청해주세요.')
        return false
      }
    },
    cctvStatChange(e) {
      this.cctvStat(e)
    },
    cctvStat(value) {
      let cctvCnt = 0
      if (this.cctv1) {
        cctvCnt++
      }
      if (this.cctv2) {
        cctvCnt++
      }
      if (this.cctv3) {
        cctvCnt++
      }
      if (this.cctv4) {
        cctvCnt++
      }
      if (value.indexOf('NR_') > -1) {
        // NVR 설치 시
        this.isNVR = true
        this.isDVR = false
        this.isCCTV = false
        this.cctv_cnt = String(cctvCnt)
      } else if (value.indexOf('DR_') > -1) {
        // DVR 설치 시
        this.isNVR = false
        this.isDVR = true
        this.isCCTV = false
        this.cctv_cnt = String(cctvCnt)
      } else if (value.indexOf('CC_') > -1) {
        // CCTV 설치 시
        this.isNVR = false
        this.isDVR = false
        this.isCCTV = true
      } else {
        // 사용안함
        this.isNVR = false
        this.isDVR = false
        this.isCCTV = false
      }
    },
    pushHikvisionCCTV(siteId, siteInfo, cctvList) {
      var rtspUri = 'rtsp://admin:abcd1234@'
      var streamUri = '/Streaming/Channels/'
      var serverName = '_defaultServer_'

      // 1. 추가할 CCTV 스트림 목록 생성
      if (this.cctv_stat.indexOf('NR_') > -1) {
        for (let i = 0; i < siteInfo.cctv_cnt; i++) {
          cctvList.push({
            name: siteId + '_' + (i + 1),
            serverName: serverName,
            uri: rtspUri + this.nvr + streamUri + (i + 1) + '01'
          })
        }
      } else if (this.cctv_stat.indexOf('CC_') > -1) {
        $.each(siteInfo, function(key, value) {
          if (/cctv[0-9]/.exec(key) && value) {
            cctvList.push({
              name: siteId + '_' + key.substr(4),
              serverName: serverName,
              uri: rtspUri + value + streamUri + '101'
            })
          }
        })
      }
    },
    // 2020-10-08 다중 CCTV (NVR, DVR) 추가 함수 통합
    pushMultipleCCTV(siteId, siteInfo, cctvList, cctvName) {
      const cctvInfo = {}
      cctvInfo['hik'] = {
        id: 'admin',
        pw: 'abcd1234'
      }
      cctvInfo['hanhwa'] = {
        id: 'admin',
        pw: 'admin123!'
      }
      cctvInfo['idis'] = {
        id: 'admin',
        pw: 'jongsan0!'
      }
      cctvInfo['webgate'] = {
        id: 'admin',
        pw: 'admin123!'
      }

      const uriFormatNVR = {}
      uriFormatNVR['hik'] = 'rtsp://%s:%s@%s/%d01'
      uriFormatNVR['hanhwa'] = 'rtsp://%s:%s@%s/ch0%d/0'
      uriFormatNVR['idis'] = 'rtsp://%s:%s@%s/trackID=%d'
      uriFormatNVR['webgate'] = 'rtsp://%s:%s@%s/ch%d/stream1'

      var serverName = '_defaultServer_'

      // 1. 추가할 CCTV 스트림 목록 생성
      for (let i = 1; i <= siteInfo.cctv_cnt; i++) {
        // nvr 변수에 dvr의 주소가 들어감
        var uri = require('sprintf-js').sprintf(
          uriFormatNVR[cctvName],
          cctvInfo[cctvName].id,
          cctvInfo[cctvName].pw,
          this.nvr,
          i
        )

        cctvList.push({
          name: siteId + '_' + i,
          serverName: serverName,
          uri: uri
        })
      }
    },
    wowzaEvent() {
      var siteId = this.saveData.siteMaster.site_id // 사이트 ID
      var siteInfo = this.saveData.siteMaster.siteInfo // 사이트정보
      // var streamFiles = [] //스트림 리스트
      var cctvList = [] // CCTV정보 리스트

      if (this.cctv_stat.indexOf('hik') > -1) {
        this.pushHikvisionCCTV(siteId, siteInfo, cctvList)
      } else {
        for (let cctvName of cctvNames) {
          if (this.cctv_stat.indexOf(cctvName) > -1) {
            this.pushMultipleCCTV(siteId, siteInfo, cctvList, cctvName)
          }
        }
      }

      // 2020-07-23 - 김진희
      // 수정 사항 반영을 위해 기존에 있던 스트림 파일은 전부 삭제하고, 새로 추가
      for (let i = 0; i < 4; i++) {
        let cctvId = siteId + '_' + (i + 1)
        console.log('i=')
        console.log(i)
        // CCTV가 있을 경우
        streamEvent({}, 'GET', '/streamfiles/' + cctvId)
          .then(response => {
            console.log('디스커넥트 및 삭제')
            // 디스커넥트
            streamEvent(
              {},
              'PUT',
              '/instances/_definst_/incomingstreams/' +
                cctvId +
                '.stream/actions/disconnectStream'
            )

            // 삭제
            streamEvent({}, 'DELETE', '/streamfiles/' + cctvId).then(
              response => {
                // 다시 추가
                if (i < cctvList.length) {
                  console.log('다시 추가')
                  let item = cctvList[i]
                  streamEvent(item, 'POST', '/streamfiles')
                }
              }
            )
          })
          .catch(response => {
            // CCTV가 없던 경우
            if (i < cctvList.length) {
              console.log('새로 추가')
              let item = cctvList[i]
              streamEvent(item, 'POST', '/streamfiles')
            }
          })
      }
      this.$router.push('/master/siteManage')
    }
  }
}
</script>

<style lang='less' scoped>
// @import '../../../assets/master.less';
#big {
  width: 500px;
}
#long {
  width: 200px;
}
.v-sheet.v-card {
  font-size: 0.8rem;
}

/deep/.v-data-table__wrapper tr {
  cursor: pointer;
}
</style>
